import {
  API_ADD_TICKET_MESSAGE,
  API_DELETE_EXTERNAL_TICKET,
  API_DELETE_INTERNAL_TICKET,
  API_GET_ALL_MESSAGES_FILTER,
  API_GET_TICKET_CONFIG,
  API_GET_TICKET_STORY,
  API_GET_TICKETS_FILTER,
} from 'config'
import Api from 'services/api'

export const getTickets = (filterData: Record<string, any>) => {
  return Api.get(API_GET_TICKETS_FILTER, filterData)
}

export const getAllTicketMessages = (ticketId: string, stackNum: number = 1) => {
  return Api.get(API_GET_ALL_MESSAGES_FILTER, {}, { ticketId, stackNum })
}

export const sendTicketMessage = (data: Record<string, any>) => {
  const files = data.files || []
  delete data.files
  return Api.uploadFiles(API_ADD_TICKET_MESSAGE, data, {}, files)
}

export const deleteInternalTicket = (id: number) => {
  return Api.delete(API_DELETE_INTERNAL_TICKET, {}, { id })
}

export const deleteExternalTicket = (id: number) => {
  return Api.delete(API_DELETE_EXTERNAL_TICKET, {}, { id })
}

export const createTicket = (data: Record<string, any>) => {
  return Api.post(API_GET_TICKETS_FILTER, data)
}

export const getConfig = () => {
  return Api.get(API_GET_TICKET_CONFIG)
}

export const getTicketStory = (ticketId: string) => {
  return Api.get(API_GET_TICKET_STORY, {}, { ticketId })
}
